<!--
  异步导出进度弹窗
  流程：调用导出接口（异步创建任务）→ 轮询 getExportTask 获取进度 → 完成后自动下载
  用法：
    <export-progress-dialog ref="exportProgress"></export-progress-dialog>
    this.$refs.exportProgress.start(() => apiFn(params), '文件名.zip');
  兼容：若后端 exec 不可用降级为同步返回 url，组件会直接下载。
-->
<template>
  <el-dialog
    title="正在导出"
    :visible.sync="show"
    width="420px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="export-progress-body">
      <el-progress
        :percentage="progress"
        :stroke-width="16"
        :status="progress >= 100 ? 'success' : ''"
        :text-inside="true"
        style="margin-bottom: 14px"
      ></el-progress>
      <p class="export-progress-msg">{{ message }}</p>
      <p class="export-progress-tip">导出文件较大，请耐心等待，页面可继续操作其他功能</p>
    </div>
  </el-dialog>
</template>

<script>
import { adminGetExportTask } from "@/api/adminModule";
import { getfile } from "@/plugins/axiosAdmin";
import { downloadFile } from "@/utils/utils";

export default {
  name: "ExportProgressDialog",
  data() {
    return {
      show: false,
      progress: 0,
      message: "正在准备导出...",
      timer: null,
      fileName: "",
    };
  },
  methods: {
    /**
     * 开始导出
     * @param {Function} apiCall 返回 {code, data:{task_id 或 url}} 的 Promise
     * @param {String} fileName 最终下载的文件名
     */
    async start(apiCall, fileName) {
      this.show = true;
      this.progress = 0;
      this.message = "正在创建导出任务...";
      this.fileName = fileName;
      try {
        const res = await apiCall();
        if (res && res.code === 200 && res.data) {
          if (res.data.url) {
            // exec 不可用时后端降级同步返回，直接下载
            this.progress = res.data.progress || 100;
            this.message = "导出完成";
            const blob = await getfile(res.data.url);
            downloadFile(blob.data, this.fileName);
            this.close();
          } else if (res.data.task_id) {
            this.poll(res.data.task_id);
          } else {
            this.fail("导出响应异常");
          }
        } else {
          this.fail((res && res.message) || "创建导出任务失败");
        }
      } catch (e) {
        this.fail("导出异常：" + (e && e.message ? e.message : e));
      }
    },
    // 轮询任务进度
    poll(taskId) {
      clearInterval(this.timer);
      this.timer = setInterval(async () => {
        try {
          const res = await adminGetExportTask(taskId);
          if (res && res.code === 200 && res.data) {
            this.progress = res.data.progress || 0;
            this.message = res.data.message || "";
            if (res.data.status === "success") {
              clearInterval(this.timer);
              const blob = await getfile(res.data.url);
              downloadFile(blob.data, this.fileName);
              this.close();
            } else if (res.data.status === "failed") {
              clearInterval(this.timer);
              this.fail(res.data.message || "导出失败");
            }
          }
        } catch (e) {
          // 网络抖动等偶发错误忽略，下一轮继续
        }
      }, 1500);
    },
    fail(msg) {
      clearInterval(this.timer);
      this.close();
      this.$message.error(msg);
    },
    close() {
      clearInterval(this.timer);
      this.show = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped lang="scss">
.export-progress-body {
  padding: 10px 6px 4px;

  .export-progress-msg {
    font-size: 13px;
    color: #888;
    text-align: center;
    margin-top: 4px;
  }

  .export-progress-tip {
    font-size: 12px;
    color: #bbb;
    text-align: center;
    margin-top: 8px;
  }
}
</style>
